import { render } from "./BaseInput.vue?vue&type=template&id=f7381788"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"
script.render = render

export default script